import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import Footer from "../MyComponents/Footer";
import { UserContext } from "./UserContext";
import API_CONFIG from "../config/api";
import "./Gallery.css";

const galleryImages = [
  "Polymath-images/Gallery photos/1.JPG", "Polymath-images/Gallery photos/2.JPG", "Polymath-images/Gallery photos/3.JPG", "Polymath-images/Gallery photos/4.JPG", "Polymath-images/Gallery photos/5.JPG", "Polymath-images/Gallery photos/6.JPG", "Polymath-images/Gallery photos/7.JPG", "Polymath-images/Gallery photos/8.JPG", "Polymath-images/Gallery photos/9.JPG", "Polymath-images/Gallery photos/10.JPG",
  "Polymath-images/Gallery photos/11.JPG", "Polymath-images/Gallery photos/12.JPG", "Polymath-images/Gallery photos/13.JPG", "Polymath-images/Gallery photos/14.JPG", "Polymath-images/Gallery photos/15.JPG", "Polymath-images/Gallery photos/16.JPG", "Polymath-images/Gallery photos/17.JPG", "Polymath-images/Gallery photos/18.JPG", "Polymath-images/Gallery photos/19.JPG", "Polymath-images/Gallery photos/20.JPG",
  "Polymath-images/Gallery photos/21.JPG", "Polymath-images/Gallery photos/22.JPG", "Polymath-images/Gallery photos/23.JPG", "Polymath-images/Gallery photos/24.JPG", "Polymath-images/Gallery photos/25.JPG", "Polymath-images/Gallery photos/26.JPG", "Polymath-images/Gallery photos/27.JPG", "Polymath-images/Gallery photos/28.JPG", "Polymath-images/Gallery photos/29.JPG", "Polymath-images/Gallery photos/30.JPG",
  "Polymath-images/Gallery photos/31.JPG", "Polymath-images/Gallery photos/32.JPG", "Polymath-images/Gallery photos/33.JPG", "Polymath-images/Gallery photos/34.JPG", "Polymath-images/Gallery photos/35.JPG", "Polymath-images/Gallery photos/36.JPG", "Polymath-images/Gallery photos/37.JPG",
  "Polymath-images/Gallery photos/41.png", "Polymath-images/Gallery photos/42.png", "Polymath-images/Gallery photos/43.png"
];

const Gallery = () => {
  const { isStudent, isTeacher, isAdmin, isGuest } = useContext(UserContext);

  const hasSidebar = isStudent || isTeacher;

  return (
    <>
      <Helmet>
        <title>Polymath-Kids Gallery - Explore Student Achievements</title>
        <meta
          name="description"
          content="Dive into the Polymath-Kids Gallery showcasing student achievements in coding, artwork, and design. See real examples of creativity and innovation."
        />
        <meta
          name="keywords"
          content="Polymath-Kids, gallery, student projects, coding, artwork, design, education"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <main className={`gallery-main ${hasSidebar ? 'with-sidebar' : 'no-sidebar'}`}>
        {/* Section 1 */}
        <section className="gallery-intro">
          <div className="gallery-intro-content">
            <h1 className="gallery-heading">
              <span className="highlight-purple">Explore Our Creative</span>
              <br />
              <span className="highlight-pink">Gallery</span>
            </h1>
            <p className="gallery-description">
              Dive into a colorful showcase of student achievements, from
              interactive projects and coding creations to artwork and design.
              This gallery highlights the diverse talents nurtured through
              Polymath-Kids programs, reflecting the creativity, problem-solving,
              and hands-on learning that students experience. Browse through real
              examples of innovation and be inspired by the imagination and
              dedication of young minds shaping the future.
            </p>
          </div>
        </section>

        {/* Section 2 */}
        <section className="gallery-section">
          <h2 className="gallery-title">
            <span className="highlight-purple">Gallery of </span>
            <span className="highlight-pink">Learning & Growth</span>
          </h2>
          <div className="gallery-grid-images">
            {galleryImages.map((imgSrc, index) => (
              <div className="gallery-item" key={index}>
                <img src={`${API_CONFIG.IMAGES_URL}/${imgSrc}`} alt={`Student work ${index + 1}`} />
              </div>
            ))}
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
};

export default Gallery;